<template>
  <header id="darkModeHeader" class="mdc-top-app-bar darkModeHeader header-width-60">
    <div class="d-flex align-items-center pdl-24 justify-conetent-between h-full">

      <div class="t-subtitle3 t-color-whiteHigh  d-flex align-items-center pdr-24 font-r t-line-1 mgr-30">
        {{ lessonName }}
      </div>
      <div class="d-flex align-items-center justify-content-end flex-grow-1 pdr-20">
        <div class="mgl-16 t-body1 t-color-whiteDisabled mgr-16 font-m">{{ $t('3722') }}</div>
        <div class="t-subtitle3 t-color-whiteHigh t-nowrap">{{ time | secondToMinFormat }}</div>
        <div class=" bg-whiteBorder h-28 mgr-12 mgl-12"></div>
	      <button
			      class="mdc-button mdc-button--outlined mdc-button--raised t-color-secondaryBtnText videoHeaderBtn b-radius4  pdl-12 pdr-12 t-nowrap"
			      @click="serverStart" @keypress="serverStart">
		      <span class="mdc-button__ripple"></span>
		      <!--Todo 정남 다국어 적용 -->
		      <span class="mdc-button__label t-body2 font-r t-color-whiteHigh">Start</span>
	      </button>
	      <button
			      class="mdc-button mdc-button--outlined mdc-button--raised t-color-secondaryBtnText videoHeaderBtn b-radius4  pdl-12 pdr-12 mgl-8 t-nowrap"
			      @click="serverStop" @keypress="serverStop">
		      <span class="mdc-button__ripple"></span>
		      <!--Todo 정남 다국어 적용 -->
		      <span class="mdc-button__label t-body2 font-r t-color-whiteHigh">Stop</span>
	      </button>
	      <div class="bg-whiteBorder w-1 h-28 mgr-12 mgl-12"></div>
        <div class="t-body1 t-color-whiteDisabled mgr-16  font-m">{{ $t('3723') }}</div>
        <div class="position-relative w-80 mgr-24">
          <div class="percentage-wrapper">
            <div class="h-2 position-relative total-percentage  bg-whiteBorder h-4">
              <div :style="{width: rate+'%'}"
                   class="real-percentage bg-saleLine b-radius0 h-4 mgt-2">
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-baseline mgr-24 t-nowrap">
          <div class="t-headline10 t-color-whiteHigh t-line-h-15 d-flex align-items-center  font-b">
            {{ rate }}
          </div>
          <div class="t-body3 font-m mgl-4 t-color-whiteHigh">%</div>
        </div>
        <button
            class="mdc-button mdc-button--outlined mdc-button--raised t-color-secondaryBtnText videoHeaderBtn b-radius4  pdl-12 pdr-12"
            @click="moveLearnViewClose" @keypress="moveLearnViewClose">
          <span class="mdc-button__ripple"></span>
          <span class="mdc-button__label t-body2 font-r t-color-whiteHigh t-nowrap">{{ $t('3182') }}</span>
        </button>
      </div>
    </div>
    <!-- <div v-if="lightModeActive" class="divider"></div> -->
  </header>
</template>

<script>
import microLearnApi from "@/api/microLearnApi";
export default {
  name: "Header",

  props: [
		'lessonName',
	  'rate',
	  'lightModeActive',
	  'time',
	  'isServerStop'
  ],

  watch: {
    lightModeActive() {
      if (!this.lightModeActive) {
        document.body.classList.add('contentDarkMode');
      } else {
        document.body.classList.remove('contentDarkMode');
      }
    }
  },

  methods: {
    moveLearnViewClose() {
      this.$emit('moveLearnViewClose');
    },

	  serverStart() {
		  this.$emit('serverStart');
	  },

	  serverStop() {
		  this.$emit('serverStop');
	  }
  },

	mounted() {
	},
}
</script>

<style scoped>

</style>
